import { useMemo } from 'react';

import { NAVIGATION_LINKS } from '~/consts/navigation';

import useCanAccessLeLens from '~/hooks/useCanAccessLeLens';

import { UserType } from '~/types/responses/users';

import { filterNavigationLinksForUser } from '~/utils/navigationLinks';

export default function useNavigationLinks(user: App.User | UserType | null | undefined) {
  const canAccessLens = useCanAccessLeLens();
  const navLinks = useMemo(() => {
    if (!user) {
      return [];
    }

    return filterNavigationLinksForUser(NAVIGATION_LINKS, user, canAccessLens);
  }, [user, canAccessLens]);

  return navLinks;
}
